// Keep the selected issuer in this tab through the OIDC redirect and reloads.
// Only the explicit demo selector is accepted; URLs cannot choose an issuer.
const key = 'sygrid-auth-source';
const params = new URLSearchParams(window.location.search);
const demoAvailable = ['dev', 'local'].includes(process.env.REACT_APP_AUTH_ENV || 'dev');
if (params.get('auth_source') === 'demo' && demoAvailable) {
  sessionStorage.setItem(key, 'demo');
  params.delete('auth_source');
  const query = params.toString();
  window.history.replaceState(window.history.state, '', window.location.pathname + (query ? `?${query}` : '') + window.location.hash);
}

export const authSource = demoAvailable && sessionStorage.getItem(key) === 'demo' ? 'demo' : 'default';
export const authChannel = authSource === 'demo' ? 'app-logout-demo' : 'app-logout';
export const clearAuthSource = () => sessionStorage.removeItem(key);
